export const SITE_ORIGIN: string =
  (import.meta.env['VITE_WEB_ORIGIN'] as string | undefined) ?? 'http://localhost:4321';

export const TURNSTILE_SITE_KEY: string =
  (import.meta.env['VITE_TURNSTILE_SITE_KEY'] as string | undefined) ?? '1x00000000000000000000AA';
